import React, { SyntheticEvent } from 'react';

import Icon from '../../assets/images/icons/exclamation.svg';
import { Tooltip } from './tooltip';

interface Props {
  info: string;
}

export function ExclamationIcon(props: Props) {
  const onClick = (e: SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };
  return (
    <Tooltip tooltip={props.info}>
      <div onClick={onClick} aria-hidden="true">
        <img src={Icon} alt="!" style={{ width: '16px' }} />
      </div>
    </Tooltip>
  );
}
